import $ from 'jquery'
import {Core} from './core'
import 'slick-carousel'
import {Tabs} from "./tabs.js";

export class SingleReadingTime {
  constructor() {
    let containerSelector = '.single-reading-time'
    this.$container = $(containerSelector)

    if (this.$container.length === 0) {
      return
    }

    this.$window = $(window)
    this.$sidebar = this.$container.find('.table-content-wrapper')

    if (this.$sidebar.length > 0) {
      this.$window.on('resize', this.handleResize.bind(this))

      setTimeout(this.fixHeightWrapperSidebar.bind(this), 980)
    }
  }

  handleResize() {
    setTimeout(this.fixHeightWrapperSidebar.bind(this), 350)
  }

  fixHeightWrapperSidebar() {
    if (Core.isBpLessThan('lg')) {
      let size = this.$sidebar.find('p').outerHeight(true)

      this.$sidebar.css('height', size + 'px')
    } else {
      this.$sidebar.css('height', 'auto')
    }
  }
}
